import { ApiClient } from '../http/api_client';
import HistoryUtil from './history_util';
import { AxiosResponse } from 'axios';

const LOADING_SPINNER_ID = 'loading_util_common_loading_spinner';

const getLoadingSpinnerHtml = () => {
  const loadingSpinnerContainer = document.createElement('div');
  const loadingSpinner = document.createElement('div');
  const loadingSpinnerContainerStyle =
    'position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 9999;';

  loadingSpinnerContainer.id = LOADING_SPINNER_ID;
  loadingSpinnerContainer.setAttribute('style', loadingSpinnerContainerStyle);
  loadingSpinnerContainer.className = 'a-spinner';
  loadingSpinner.className = 'a-spinner_inner';

  loadingSpinnerContainer.append(loadingSpinner);
  return loadingSpinnerContainer;
};
const showLoadingSpinner = () => {
  document.body.append(getLoadingSpinnerHtml());
};
const hideLoadingSpinnerHtml = () => {
  return document.getElementById(LOADING_SPINNER_ID)?.remove();
};

function changeBrowserUrl(url: string) {
  HistoryUtil.pushNewUrlToHistory(url);
}

const forceGotoUrl = (url: string): any => {
  window.location.href = url;
};

const loadPageWithAjaxLoading = (url: string, isPushState: boolean, promise?: Promise<Document>): Promise<Document> => {
  return new Promise((resolve) => {
    showLoadingSpinner();

    const httpFetch = promise || ApiClient.get(url, {responseType: "document"});
    httpFetch
      .then((resp) => {
        hideLoadingSpinnerHtml();
        if (isPushState) {
          changeBrowserUrl(url);
        }

        try {
          const doc: Document = (resp as AxiosResponse).data || resp;
          resolve(doc);
        } catch (e) {
          forceGotoUrl(url);
        }
      })
      .catch(() => {
        forceGotoUrl(url);
      });
  });
};

/**
 * 指定したURLもしくはpromiseより新しいHTMLのDocumentを取得する。
 * Document取得済んだ後、指定したURLでブラウザのURLアドレスを変更する。
 *
 * @param url pushState/replaceStateがサポートする場合、JSでブラウザURL変更。サポートしない場合、新しいページ開く。
 * @param promise 取得先がURLと異なる(但し、ブラウザのURL変更したい)場合、HTML取得のpromiseを渡す。例えばrepositoryのAPIを利用する場合
 */
const asyncPage = (url: string, promise?: Promise<Document>): Promise<Document> => {
  if (HistoryUtil.isBrowserSupportsHistory()) {
    return loadPageWithAjaxLoading(url, true, promise);
  }
  return forceGotoUrl(url);
};

const onHistoryBack = (callback: (newDoc: Document) => void) => {
  if (HistoryUtil.isBrowserSupportsHistory()) {
    window.onpopstate = () => {
      loadPageWithAjaxLoading(document.location.href, false)
        .then(newDoc => callback(newDoc));
    };
  }
};

function getHrefOrDataUrl(el: Element) {
  return el.getAttribute('href') || el.getAttribute('data-url');
}

/**
 * 画面上のリンクやボタンをクリックされ、画面同期で遷移される場合を非同期にさせる。
 * 例えば画面のページングのリンクを非同期させたい場合に利用。
 * Container作らなくても良い簡易パターンです。
 *
 *  注意点：
 * リンクの場合は、href属性が必要
 * ボタンなどの場合は、data-url属性が必要
 *
 * @param initSelectors リンク（href属性が必要）やボタンなど（data-url属性が必要）を特定するためのselector
 * @param onLoad 非同期でDocumentを読み終わったら画面内容を置換する必要なselectorと、イベントが発生した要素
 */
const asyncPageWithSelectors = (initSelectors: string[], onLoad: (newModel: Document, target:HTMLElement) => void) => {
  const asyncClick = (e: Event) => {
    const target = e.target as HTMLElement
    e.preventDefault();
    const url = getHrefOrDataUrl(e.target as Element);
    if (url) {
      console.log('start fetching page..', url);
      asyncPage(url).then((newDoc) => {
        console.log('done fetching page..', url);
        onLoad(newDoc, target);
      });
    }
  };
  document.querySelectorAll(initSelectors.join(',')).forEach((el) => {
    if (getHrefOrDataUrl(el)) {
      // Prevent duplicated event add
      el.removeEventListener('click', asyncClick, false);
      el.addEventListener('click', asyncClick, false);
    }
  });
};

const LoadingUtil = {
  asyncPage,
  asyncPageWithSelectors,
  onHistoryBack
};
export default LoadingUtil;
